import { render, staticRenderFns } from "./OnlineHealthConsultation.vue?vue&type=template&id=3581e438&scoped=true&"
import script from "./OnlineHealthConsultation.vue?vue&type=script&lang=js&"
export * from "./OnlineHealthConsultation.vue?vue&type=script&lang=js&"
import style0 from "./OnlineHealthConsultation.vue?vue&type=style&index=0&id=3581e438&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581e438",
  null
  
)

export default component.exports